import { Popover } from '@mui/material';
import React, { memo } from 'react';

interface Props {
  anchorEl: HTMLElement | null;
  children: React.ReactNode;
  onClose: () => void;
}

const Component: React.FC<Props> = ({ anchorEl, children, onClose }) => {
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      open={!!anchorEl}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClose={onClose}
    >
      {children}
    </Popover>
  );
};

export const ChartPopover = memo(Component);
